/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListBillings200ResponseDataInner } from './ListBillings200ResponseDataInner';
import {
    ListBillings200ResponseDataInnerFromJSON,
    ListBillings200ResponseDataInnerFromJSONTyped,
    ListBillings200ResponseDataInnerToJSON,
    ListBillings200ResponseDataInnerToJSONTyped,
} from './ListBillings200ResponseDataInner';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';

/**
 * 
 * @export
 * @interface ListBillings200Response
 */
export interface ListBillings200Response {
    /**
     * 
     * @type {Array<ListBillings200ResponseDataInner>}
     * @memberof ListBillings200Response
     */
    data: Array<ListBillings200ResponseDataInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof ListBillings200Response
     */
    paging: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the ListBillings200Response interface.
 */
export function instanceOfListBillings200Response(value: object): value is ListBillings200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('paging' in value) || value['paging'] === undefined) return false;
    return true;
}

export function ListBillings200ResponseFromJSON(json: any): ListBillings200Response {
    return ListBillings200ResponseFromJSONTyped(json, false);
}

export function ListBillings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBillings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ListBillings200ResponseDataInnerFromJSON)),
        'paging': ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function ListBillings200ResponseToJSON(json: any): ListBillings200Response {
    return ListBillings200ResponseToJSONTyped(json, false);
}

export function ListBillings200ResponseToJSONTyped(value?: ListBillings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ListBillings200ResponseDataInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

